import {
  findLoginUserInfo,
  findUserInfoByToken,
  findUserRoleIdList,
  findSchoolById,
  getPlatFormInfoByUserIdAPI,
  getCommonCatchListByAppTypes,
  loginByTokenAPI
} from '@/service/api';
import {
  setToken,
  setUserId,
  removeToken,
  removeUserId
} from '@/library/js/auth';
import { JsonGet } from "@/service";

// const user = {
export default {
  namespaced: true,
  state: {
    token: '',
    name: "",
    userId: '',
    userName: "",
    userHeadImg: "",
    schoolId: "",
    schoolName: "",
    adminType: "",
    userType: "",
    classAdmin: 0,
    subjectId: '',
    subjectName: '',
    roleIds: '',
    schoolFrom: '',
    phase: '',
    origin: '',
    regionAdminInfo: '',
    weakPassword: '',
    Authorization: '',
    mobile: '',
    //是否需要验证码登录
    isCodeLogin: false,
  },

  mutations: {
    SET_AUTHORIZATION: (state, Authorization) => {
      state.Authorization = Authorization;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_USERID: (state, userId) => {
      state.userId = userId;
    },
    SET_USERNAME: (state, userName) => {
      state.userName = userName;
    },
    SET_USERHEADIMG: (state, userHeadImg) => {
      state.userHeadImg = userHeadImg;
    },
    SET_SCHOOLID: (state, schoolId) => {
      state.schoolId = schoolId;
    },
    SET_SCHOOLNAME: (state, schoolName) => {
      state.schoolName = schoolName;
    },
    SET_ADMINTYPE: (state, adminType) => {
      state.adminType = adminType;
    },
    SET_USERTYPE: (state, userType) => {
      state.userType = userType;
    },
    SET_SUBJECTID: (state, subjectId) => {
      state.subjectId = subjectId;
    },
    SET_SUBJECTNAME: (state, subjectName) => {
      state.subjectName = subjectName;
    },
    SET_ROLEIDS: (state, roleIds) => {
      state.roleIds = roleIds;
    },
    SET_SCHOOLFROM: (state, schoolFrom) => {
      state.schoolFrom = schoolFrom;
    },
    SET_PHASE: (state, phase) => {
      state.phase = phase;
    },
    SET_ORIGIN: (state, origin) => {
      state.origin = origin;
    },
    SET_REGIONADMININFO: (state, regionAdminInfo) => {
      state.regionAdminInfo = regionAdminInfo;
    },
    SET_WEAKPASSWORD: (state, weakPassword) => {
      state.weakPassword = weakPassword;
    },
    SET_MOBILE: (state, mobile) => {
      state.mobile = mobile;
    },
    SET_ISCODELOGIN: (state, isCodeLogin) => {
      state.isCodeLogin = isCodeLogin;
    },
    SET_CLASSADMIN: (state, classAdmin) => {
      state.classAdmin = classAdmin;
    },
  },

  actions: {
    //根据token获取Author
    getAuthorization({
      dispatch,
      commit
    }, token) {
      return new Promise((resolve, reject) => {
        loginByTokenAPI({
          tokenId: token
        }).then(res => {
          if (res && res.code > 0) {
            commit("SET_AUTHORIZATION", res.result.token);
            resolve(res.result)
          } else {
            reject(res.msg)
          }
        })
      });
    },
    // 获取用户信息
    getUserInfo({
      dispatch,
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        let funName = userInfo.token ? findUserInfoByToken : findLoginUserInfo;
        let params = {};
        if (userInfo.token) {
          params.token = userInfo.token;
        }
        if (userInfo.userId) {
          params.userId = userInfo.userId;
        }
        // let params = {
        //   userId: userInfo.userId
        //   token: userInfo.token
        // }
        funName(params)
          .then(function (response) {
            if (response && response.code > 0) {
              const data = response.data;
              // dispatch('getAuthorization', data.token)
              commit("SET_TOKEN", data.token);
              commit("SET_NAME", data.realname);
              commit("SET_USERID", data.id);
              commit("SET_USERNAME", data.user_name);
              commit("SET_USERHEADIMG", data.avatar);
              commit("SET_SCHOOLID", data.user_type == '6' ? "" : data.schoolid);
              commit("SET_SCHOOLNAME", data.user_type == '6' ? "" : data.school_name);
              commit("SET_ADMINTYPE", data.admin_type);
              commit("SET_USERTYPE", data.user_type);
              commit("SET_SUBJECTID", data.subjectid);
              commit("SET_SUBJECTNAME", data.sub_name_list);
              commit("SET_ORIGIN", data.origin);
              commit("SET_PHASE", data.phase);
              commit("SET_MOBILE", data.mobile);
              commit("SET_CLASSADMIN", data.classAdmin);
              if (userInfo.isSaveCookie) {
                setToken(data.token);
                setUserId(data.id);
              }
              // resolve(response);
              dispatch('getUserRole', {
                userId: data.id
              }).then(() => {
                // 当前用户为班主任 获取当前用户的学校来源
                if (data.admin_type === 2 || data.admin_type === 3) {
                  dispatch('getSchoolById', {
                    schoolId: data.schoolid
                  }).then(() => {
                    resolve(response);
                  });
                } else {
                  resolve(response);
                }
                // 查询当前用户是否为弱密码
                // if (data.admin_type === 1 || data.user_type === 4 || data.user_type === 5 || data.user_type === 6) {
                debugger;
                dispatch('getUserPwd', {
                  uId: data.id,
                  appTypes: 403
                }).then(() => { });
                // }
              });
              if (data.user_type == '6') {
                dispatch('getRegionInfoByUserId', {
                  userId: data.id
                }).then(() => { });
              }
              JsonGet(`https://fs.iclass30.com/aliba/console/logo/json/loginByCode.json?v=${Date.now()}`).then((res) => {
                let curData = res.data.filter((item) => { return item.schoolId === data.schoolid })[0]
                if (curData) {
                  commit("SET_ISCODELOGIN", data.state === 1);
                }
              })
            } else {
              reject(response.msg);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 获取用户角色
    getUserRole({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        findUserRoleIdList(userInfo)
          .then(function (response) {
            if (response && response.code > 0) {
              const data = response.data;
              if (data.length > 0) {
                commit("SET_ROLEIDS", data.join(','));
              }
              resolve(response);
            } else {
              reject(response.msg);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 根据用户类型（6：区域管理员）的用户id获取该用户信息
    getRegionInfoByUserId({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        getPlatFormInfoByUserIdAPI(userInfo)
          .then(function (response) {
            if (response && response.code > 0) {
              const data = response.data;
              if (Object.keys(data).length > 0) {
                commit("SET_REGIONADMININFO", JSON.stringify(data))
              }
              resolve(response);
            } else {
              reject(response.msg);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 获取当前用户的学校来源
    getSchoolById({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        findSchoolById(userInfo)
          .then(function (response) {
            if (response && response.code > 0) {
              const data = response.data;
              if (data) {
                commit("SET_SCHOOLFROM", data.schoolFrom);
              }
              resolve(response);
            } else {
              reject(response.msg);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 判断登录账号密码是否为弱密码
    getUserPwd({
      commit
    }, userInfo) {
      return new Promise((resolve, reject) => {
        getCommonCatchListByAppTypes(userInfo)
          .then(function (response) {
            if (response && response.code > 0) {
              const data = response.data;
              if (data) {
                if (data.length > 0) {
                  let param = data[0].catch_list.replace(/\{|}/g, "");
                  let arr = param.split(":");
                  if (arr[1] == "true") {
                    commit("SET_WEAKPASSWORD", true);
                  } else {
                    commit("SET_WEAKPASSWORD", false);
                  }
                }
              }
              resolve(response);
            } else {
              reject(response.msg);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // 登出
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        commit("SET_NAME", '');
        commit("SET_USERID", '');
        commit("SET_USERNAME", '');
        commit("SET_USERHEADIMG", '');
        commit("SET_SCHOOLID", '');
        commit("SET_SCHOOLNAME", '');
        commit("SET_ADMINTYPE", '');
        commit("SET_USERTYPE", '');
        commit("SET_SUBJECTID", '');
        commit("SET_MOBILE", '');
        commit("SET_CLASSADMIN", 0);
        removeToken();
        removeUserId();
        resolve();
      });
    },
    // 移除 token
    resetToken({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        removeToken();
        resolve();
      });
    },
    // 改变当前学校来源
    setSchoolFrom({
      commit
    }, data) {
      commit('SET_SCHOOLFROM', data);
    }
  }
};
// export default user;